import { FormattedMessage } from "react-intl";
import folderIcon from "../../../../assets/management/folder.svg";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import ManagementHeader, {
  ManagementHeaderDivider,
} from "../../ManagementHeader/ManagementHeader";
import UsersCount from "../../ManagementHeader/UsersCount/UsersCount";
import styles from "./ManageEntitiesHeader.module.css";

type ManageEntitiesHeaderProps = {
  totalEntities?: number;
  users?: {
    total?: number;
    active?: number;
    inactive?: number;
  };
};

const ManageEntitiesHeader = ({
  totalEntities,
  users,
}: ManageEntitiesHeaderProps) => {
  return (
    <ManagementHeader className="d-sm-flex justify-content-end">
      <div className="d-flex align-items-center mb-2 mb-sm-0">
        <span className="d-flex align-items-center">
          <BaseIcon icon={folderIcon} className={`${styles.icon} mx-1`} />
          <strong>
            <FormattedMessage
              id="MANAGEMENT.ENTITIES"
              defaultMessage="Entities"
            />
            :
          </strong>
          &nbsp;
          <FormattedMessage id="GLOBAL.TOTAL" defaultMessage="Total" />
          &nbsp;{totalEntities}
        </span>
        <ManagementHeaderDivider />
      </div>

      <UsersCount extended {...users} />
    </ManagementHeader>
  );
};

export default ManageEntitiesHeader;
